const cardTopupTableColumns = [
  {
    prop: 'card.masked_number',
    name: 'Card number',
    sortable: false,
    minWidth: 120,
    flexGrow: 1,
  },
  {
    prop: 'card.name',
    orderingParam: 'card_name',
    name: 'Card name',
    minWidth: 120,
    flexGrow: 1,
  },
];

const amountColumn = {
  prop: 'amount',
  orderingParam: 'amount',
  name: 'Target balance',
  cellClass: 'text-end',
  headerClass: 'text-end',
  minWidth: 100,
  canAutoResize: false,
};

const actionsColumn = {
  prop: 'actions',
  name: '',
  sortable: false,
  width: 60,
  resizeable: false,
  canAutoResize: false,
  cellClass: 'text-center',
};

export const immediateTopupTableColumns = [
  {
    prop: 'created',
    name: 'Date',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  ...cardTopupTableColumns,
  {
    prop: 'card.holder.first_name',
    name: 'Cardholder',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  {
    prop: 'creator.first_name',
    name: 'Transferred by',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  {
    prop: 'amount',
    orderingParam: 'amount',
    name: 'Amount',
    cellClass: 'text-end',
    headerClass: 'text-end',
    minWidth: 100,
    canAutoResize: false,
  },
];

export const recurringTopupTableColumns = [
  ...cardTopupTableColumns,
  {
    prop: 'employee.first_name',
    name: 'Cardholder',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  {
    prop: 'frequency',
    name: 'Frequency',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  amountColumn,
  actionsColumn,
];

export const scheduledTopupTableColumns = [
  ...cardTopupTableColumns,
  {
    prop: 'employee.first_name',
    name: 'Cardholder',
    minWidth: 120,
    sortable: false,
    flexGrow: 1,
  },
  {
    prop: 'date_start',
    name: 'Period',
    minWidth: 200,
    sortable: false,
    flexGrow: 1,
  },
  {
    prop: 'schedule_status',
    name: 'Status',
    minWidth: 80,
    sortable: false,
    canAutoResize: false,
  },
  amountColumn,
  actionsColumn,
];
